// (function($) {
//   // Site title
//   wp.customize('blogname', function(value) {
//     value.bind(function(to) {
//       $('.brand').text(to);
//     });
//   });
// })(jQuery);

var currentElemDesk = null;
var currentElemMob = null;
var currentTria = null;

jQuery(document).ready(function() {
  jQuery.each(jQuery('.methode-item'), function(index, elem){
    var elemID = jQuery(elem).attr('item');
    var descrElemMob = jQuery(".methode-content[item=" + elemID + "][mobile]");
    var descrElemDesk = jQuery(".methode-content[item=" + elemID + "][desktop]");
    var triangle = jQuery(elem).find('.triangle');
    jQuery(elem).click(function() {
      if(currentElemDesk == null){
        jQuery(descrElemMob).fadeToggle();
        jQuery(descrElemDesk).fadeToggle();
        jQuery(triangle).toggle();
        currentElemDesk = descrElemDesk;
        currentElemMob = descrElemMob;
        currentTria = triangle;
      } else {
        if (!jQuery(currentElemDesk).is(jQuery(descrElemDesk))) {
          jQuery(currentElemDesk).fadeToggle(400, 'swing', function () {
            jQuery(descrElemDesk).fadeToggle();
          });
          jQuery(currentElemMob).fadeToggle(400, 'swing', function () {
            jQuery(descrElemMob).fadeToggle();
          });
          jQuery(currentTria).toggle();
          jQuery(triangle).toggle();
          currentElemDesk = descrElemDesk;
          currentElemMob = descrElemMob;
          currentTria = triangle;
        } else {
          jQuery(descrElemMob).fadeToggle();
          jQuery(descrElemDesk).fadeToggle();
          jQuery(triangle).toggle();
          currentElemDesk = null;
          currentElemMob = null;
          currentTria = null;
        }
      }
    })
  });
});